import { AddressDto } from "./address.dto";

export class CustomerDto {
  name: string;
  document: string;
  email: string;
  phone: string;
  additionalPhone?: string;
  address: AddressDto;
  }